function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

class BaseClass {
    constructor(element) {
        this.element = element;
        this.element.wrapper = this;
        this.eventListeners = [];
    }

    addEventListener(eventType, callback) {
        this.eventListeners.push({
            eventType, callback
        });
    }

    raiseEvent(eventType, data = undefined) {
        this.eventListeners
            .filter(x => x.eventType === eventType)
            .forEach(x => x.callback(data));
    }
}


//toggle class
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll("[data-tc-target]").forEach(i => {

        i.addEventListener('click', e => {

            e.preventDefault();

            let targetElement = e.target.dataset.tcTarget;

            let setClass = e.target.dataset.tcClass;
            if (setClass === undefined) {
                setClass = 'open';
            }

            document.querySelectorAll(targetElement).forEach(t => {
                t.classList.toggle(setClass);
            });

            if (e.target.dataset.tcHtmlOverflow) {
                document.querySelector('html').classList.toggle(e.target.dataset.tcHtmlOverflow);
            }

        })
    });

});


async function stall(stallTime = 500) {
    await new Promise(resolve => setTimeout(resolve, stallTime));
}


function elementContentOverflows(element) {

    const parentWidth = element.getBoundingClientRect().width;
    const childElements = element.querySelectorAll(`:scope > *`);
    let childElementTotalWidth = 0;

    childElements.forEach(i => {
        const currentItemStyling = window.getComputedStyle(i);
        const currentItemWidth = parseFloat(currentItemStyling.width) + parseFloat(currentItemStyling.marginLeft) + parseFloat(currentItemStyling.marginRight);
        childElementTotalWidth += currentItemWidth;
    });

    return (parseInt(childElementTotalWidth) > parseInt(parentWidth));

}

function toggleClass(el, className) {
    if (el.classList) {
        el.classList.toggle(className);
    } else {
        var classes = el.className.split(' ');
        var existingIndex = classes.indexOf(className);

        if (existingIndex >= 0)
            classes.splice(existingIndex, 1);
        else
            classes.push(className);

        el.className = classes.join(' ');
    }
}

function limitNumberWithinRange(num, min, max){
    const MIN = min || 1;
    const MAX = max || 20;
    const parsed = parseInt(num)
    return Math.min(Math.max(parsed, MIN), MAX)
}